import React, { Component } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import * as _ from '../lodash';
import Modal from '../components/Modal';
import VariantSelect from './components/VariantSelect';
import LocationSelect from './components/LocationSelect';
import ResourceSelect from './components/ResourceSelect';
import QuantityInput from './components/QuantityInput';
import DatePicker from '../components/DatePicker';
import Submit from './components/Submit';
import Alert from '../components/Alert';
import Price from './components/Price';
import TimeZone from '../components/Common/TimeZone';
import { SHORT_DATE_FORMAT } from '../constants';
import Spinner from '../components/Spinner';
import Translation from '../utilities/localizationUtility';
import { capitalize, parseAvailableDates } from '../utilities/helperUtility';
import TimeSlots from './components/TimeSlots';
import VariantsBlock from './components/VariantsBlock';
import BookingFieldsBlock from './components/BookingFieldsBlock';
import LocationBlock from './components/LocationBlock';
import Button from '../components/Common/Button';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { stringToBoolean } from '../utilities/conversionUtility';
import ExceededMessage from "../components/exceeded_free_trial_message.js"

export default class AppointmentWidgetPage extends Component {
  state = {
    currentMonth: null,
    availableDates: [],
    daySelected: null,
    start: null,
    finish: null,
  };

  onDayClick = this.onDayClick.bind(this);

  onSelectTimeSlot = this.onSelectTimeSlot.bind(this);

  dayDisabled = this.dayDisabled.bind(this);

  dayMouseEnter = this.dayMouseEnter.bind(this);

  onMonthClick = this.onMonthClick.bind(this);

  onBookingFieldChanged = this.onBookingFieldChanged.bind(this);

  renderDay = this.renderDay.bind(this);

  ref = React.createRef();

  UNSAFE_componentWillReceiveProps(nextProps) {
    const {
      timeslots,
      minDate,
      maxDate,
      timeZone,
      resources,
      order: nextOrder,
      frameActions: { fetchBlocks },
      orderActions: { setSelectedResource },
      setting,
      exceededTrialPlan
    } = nextProps;

    const { order: preOrder, setting: prevSetting } = this.props;
    const { currentMonth } = this.state;
    const interval = parseInt(setting.interval, 10)
    const intervalUnit = setting.interval_unit || 'hours'
    const intervalUnitMultiplier = intervalUnit == 'minutes' ? 1 : 60
    const intervalValue = isNaN(interval) ? null : interval*intervalUnitMultiplier
    let start = '';
    let finish = '';
    let date = '';

    if (currentMonth) {
      date = currentMonth;
    } else {
      date = moment(new Date());
      if (minDate) {
        date = date.clone().add(minDate, 'seconds');
      }
      this.setState({ currentMonth: date });
    }

    start = moment([date.year(), date.month()]);
    finish = moment(start).endOf('month');
    const availableDatesTemp = parseAvailableDates(timeslots, minDate, maxDate, timeZone);

    if (availableDatesTemp.length >= 0) {
      this.setState({ availableDates: availableDatesTemp });
    }

    if (!nextOrder.selectedResource && resources.length == 1) {
      setSelectedResource(resources[0])
    }

    // TODO variantSelected should refactor to object, its ID now
    if (
      nextOrder.variantSelected
      && (!_.isEqual({...nextOrder, ...{quantity: 1}}, {...preOrder, ...{quantity: 1}})
        || (!_.isEqual(prevSetting, setting))
      )
      // The interval cannot be less than 15 minutes
      && (!interval
        || !(intervalUnit == 'minutes' && (interval > 0 && interval < 15))
      )
      && !exceededTrialPlan
    ) {
      fetchBlocks(
        nextOrder.variantSelected,
        start,
        finish,
        nextOrder.selectedLocation ? nextOrder.selectedLocation.id : null,
        nextOrder.selectedResource ? nextOrder.selectedResource.id : null,
        intervalValue
      );
    }
  }

  onDayClick(day, available) {
    // if the date is available
    const { availableDates } = this.state;
    const date = moment(day).format(SHORT_DATE_FORMAT);
    const nbr = this.getSpaceOnDay(date);
    if (nbr && availableDates.includes(date)) {
      this.setState({ daySelected: day, timeSlotSelected: null });
    } else {
      this.setState({ daySelected: null, timeSlotSelected: null });
    }
  }

  onMonthClick(day) {
    const {
      order: preOrder,
      exceededTrialPlan,
      frameActions: { fetchBlocks },
      setting: { interval_unit },
    } = this.props;

    const date = moment(day);
    const start = moment([date.year(), date.month()]);
    const finish = moment(start).endOf('month');
    const intervalUnit = interval_unit || 'hours';
    const interval = parseInt(this.props.setting.interval, 10)
    const intervalUnitMultiplier = intervalUnit == 'minutes' ? 1 : 60;
    const intervalValue = isNaN(interval) ? null : interval*intervalUnitMultiplier;

    this.setState({ currentMonth: moment(day), daySelected: null, timeSlotSelected: null });

    if (!exceededTrialPlan) {
      fetchBlocks(
        preOrder.variantSelected,
        start,
        finish,
        preOrder.selectedLocation ? preOrder.selectedLocation.id : null,
        preOrder.selectedResource ? preOrder.selectedResource.id : null,
        intervalValue
      );
    }
  }

  onBookingFieldChanged(key, value) {
    const { orderActions, setting: { show_booking_fields: showBookingFields } } = this.props;
    let { order: { bookingFields } } = this.props;
    if (showBookingFields && showBookingFields[key]) {
      const name = showBookingFields[key].label;
      const type = showBookingFields[key].type;
      const existing = bookingFields.find(x => x.key === key);
      if (existing) {
        bookingFields = bookingFields.map(x => {
          if ( x.key === key) {
            if (x.type === 'checkbox') {
              const v = _.uniq(x.value.concat([value]));
              return {key, name, value: v, type };
            }
            return {key, name, value, type};
          }

          return x;
        });
      } else {
        bookingFields.push({key, name, value: [value], type});
      }
      orderActions.setBookingFields(bookingFields);
    }
  }

  onSubmit(e) {
    const { orderActions, cartActions } = this.props;
    const ele = e.target;
    const messages = [];
    if (!messages.length) {
      ele.disabled = true;
      orderActions
        .submitAppointment()
        .then((response) => {
          const { reservation } = response.data;
          if (reservation.items.some(x => x.status !== 'ok')) {
            let m = 'SCHEDULE CONFLICT PLEASE RELOAD PAGE';

            if (window.screen.width < 380) m = 'PLEASE RELOAD PAGE';
            this.alert.show('red', [m]);
            ele.innerText = m;
          } else {
            cartActions.addItems(reservation, ['Date', 'Time', 'Resource', '_resource_ids']);
          }
        })
        .catch((responsed) => {
          ele.disabled = false;
          const { response } = responsed;
          if (response && response.data) {
            const { data } = response;

            Object.keys(data).forEach((key) => {
              const name = key
                .split('_')
                .map(x => capitalize(x))
                .join('');
              messages.push(`${name} ${data[key]}`);
            });

            this.alert.show('red', ['SERVER ERROR']);
          } else {
            this.alert.show('red', ['SOMETHING WRONG']);
            throw responsed;
          }
        });
    } else {
      this.alert.show('red', messages);
    }
  }

  onSelectTimeSlot(timeSlot) {
    if (this.alert) { this.alert.close() };
    if (timeSlot.available >= this.props.order.quantity) {
      const {
        orderActions: { setTimeSlot },
      } = this.props;

      const {valid, message} = this.checkValidResourceAndLocation();

      setTimeSlot({
        timeSlot,
      });

      if (valid) {
        this.openModal();
        this.setState({ timeSlotSelected: timeSlot });
      } else {
        this.alert.show('red', [message]);
      }
    }
  }

  checkValidResourceAndLocation() {
    const {
      order,
      capacity,
      locations,
      setting
    } = this.props;

    const showLocation = stringToBoolean(setting.show_location_chooser),
          showResource = stringToBoolean(setting.show_resource_chooser),
          enableResourceDropdown = showResource && capacity.type == 2,
          enableLocationDropdown = showLocation && locations.length > 0;

    let valid = true,
        message = 'Select ';

    if (enableResourceDropdown && !order.selectedResource) {
      valid = false;
      message += "Resource"
    }

    if (enableLocationDropdown && !order.selectedLocation) {
      valid = false;
      if (message.indexOf('Resource') > -1 ) { message += " and " }
      message += "Location"
    }

    return {valid: valid, message: message}
  }

  dayDisabled(value) {
    const currentDate = new Date(Date.now());
    const day = moment(value).format(SHORT_DATE_FORMAT);
    const { availableDates } = this.state;
    if (!availableDates.includes(day) || moment(value).isBefore(currentDate.setHours(0, 0, 0, 0)) || (this.getSpaceOnDay(day) == 0)) {
      return new Date(day);
    }
    return null;
  }

  renderTimeSlot(value) {
    const {
      style: { li },
      setting,
      theme,
      timeslots,
      timeZone,
      locale,
      order: { quantity }
    } = this.props;

    const { availableDates, timeSlotSelected } = this.state;
    const isDisplayRange = stringToBoolean(setting.display_time_range);
    const isShowRemainingSpace = stringToBoolean(setting.show_remaining_places);
    const timeFormat = setting.time_format;
    const self = this;

    return (
      <TimeSlots
        timeslots={timeslots}
        timeZone={timeZone}
        locale={locale}
        isDisplayRange={isDisplayRange}
        isShowRemainingSpace={isShowRemainingSpace}
        availableDates={availableDates}
        li={li}
        highlightColor={theme.highlightColor}
        timeFormat={timeFormat}
        selectedTimeSlot={timeSlotSelected}
        selectedDate={value}
        onItemClick={self.onSelectTimeSlot}
        quantity={quantity}
      />
    );
  }

  dayMouseEnter(event, value, available) {
    const { availableDates } = this.state;
    const day = moment(value).format(SHORT_DATE_FORMAT);
    const currentDate = new Date(Date.now());
    if (availableDates.includes(day) && moment(value).isAfter(currentDate.setHours(0, 0, 0, 0))) {
      if (event.currentTarget) {
        if (event.currentTarget.childNodes.length > 1) {
          const toolTipElement = event.currentTarget.childNodes[0];
          if (toolTipElement.style) {
            toolTipElement.style.opacity = '1';
          }
        }
      }
    }
  }

  dayMouseOut(event, value, available) {
    const { availableDates } = this.state;
    const day = moment(value).format(SHORT_DATE_FORMAT);
    const currentDate = new Date(Date.now());
    if (availableDates.includes(day) && moment(value).isAfter(currentDate.setHours(0, 0, 0, 0))) {
      if (event.currentTarget) {
        if (event.currentTarget.childNodes.length > 1) {
          const toolTipElement = event.currentTarget.childNodes[0];
          if (toolTipElement.style) {
            toolTipElement.style.opacity = '0';
          }
        }
      }
    }
  }

  isTimeslotsUnderSelectedDay() {
    const { setting } = this.props;
    return !setting.timeslots_position || this.props.setting.timeslots_position == 'under_selected_day';
  }

  checkShowTimeSlot() {
    const { daySelected } = this.state;
    const timeSlots = this.renderTimeSlot(daySelected);
    if (timeSlots.props.timeslots.length) {
      const result = (
        <div className="text-left" ref={this.ref}>
          {timeSlots}
        </div>
      );
      const { ref } = this;
      setTimeout(() => {
        // trick to trigger react transition
        // we can not use visibility here due to it need to overwrite plugin
        if (ref.current) ref.current.style.maxHeight = '180px';
      }, 1);
      return result;
    }

    return null;
  }

  renderTimeslots() {
    return (
      <React.Fragment>
        <Alert ref={ref => (this.alert = ref)} />
        {this.checkShowTimeSlot()}
      </React.Fragment>
    );
  }

  renderDay(day) {
    const date = day.getDay();
    let left = null;
    if (date === 6) {
      left = '-35%';
    } else {
      left = '85%';
    }

    const nbr = this.getSpaceOnDay(day)

    if (nbr > 0) {
      return (
        <div
          style={{ position: 'relative', width: '100%', height: '100%' }}
          onMouseEnter={e => this.dayMouseEnter(e, day, nbr)}
          onMouseLeave={e => this.dayMouseOut(e, day, nbr)}
        >
          <div className="day-tool-tip" style={{ left }}>
            <span>{nbr || 0}</span>
          </div>
          <span>{day.getDate()}</span>
        </div>
      );
    } else {
      return (
        <div style={{ position: 'relative', width: '100%', height: '100%' }}>
          <span>{day.getDate()}</span>
        </div>
      );
    }
  }

  getSpaceOnDay(day) {
    const { timeslots, order: { quantity = 1 } } = this.props,
          dayFormat = moment(day).format(SHORT_DATE_FORMAT),
          blockTimeSlot = _.find(timeslots, { date: dayFormat });
    if (blockTimeSlot) return blockTimeSlot.timeslots.filter(x => x.available >= quantity ).length;
    return 0;
  }

  render() {
    const {
      style,
      setting,
      defaultSetting,
      exceededTrialPlan,
      order: { selectedLocation, selectedResource, bookingFields, variants, totalPrice },
      maxDate,
      minDate,
      timeZone,
      locale,
      googleApiKey,
      translation,
      locations,
      resources,
      region,
      productTitle,
      capacity,
    } = this.props;

    const today = moment(new Date()).tz(timeZone),
          { daySelected, currentMonth, timeSlotSelected } = this.state,
          t = new Translation(this.props);

    let firstDate = today,
        location = selectedLocation,
        lastDate = '',
        mapUrl = '';

    if (minDate) {
      firstDate = moment(firstDate.clone().add(minDate, 'seconds')).format(SHORT_DATE_FORMAT);
    } else {
      firstDate = moment(firstDate).format(SHORT_DATE_FORMAT);
    }

    lastDate = maxDate ? moment(today).add(maxDate, 'days') : today.add(2, 'years');

    if (!location && locations.length == 1) location = locations[0]

    if (location && location.address) {
      let address = location.address;
      let queryArray = address.split(',').map(function(el) {
        return el.trim().replace(' ', '+');
      });
      let query = queryArray.join();
      mapUrl = `https://www.google.com/maps/embed/v1/place?q=${query}&key=${googleApiKey}`;
    }

    const currentBookingFields = setting.show_booking_fields ? Object.values(setting.show_booking_fields).map(x => {
      const ordered = _.first(bookingFields.filter(y => y.key === x.key));
      return ordered ? {...x, ...ordered} : x;
    }) : [];

    const variantsValue = Object.values(variants),
          canBook = variantsValue.length,
          showLocationChooser = stringToBoolean(setting.show_location_chooser),
          showResourceChooser = stringToBoolean(setting.show_resource_chooser),
          showQuantityChooser = stringToBoolean(setting.show_quantity_chooser),
          showLocationMap = stringToBoolean(setting.show_location),
          enableLocationDropdown = showLocationChooser && locations.length > 0,
          enableResourceDropdown = showResourceChooser && capacity.type == 2 && resources.length > 1,
          enableVariantDropdown = this.props.variants.length > 1,
          additionalStyle = {...style.body, ...{textAlign: 'center', navButtonOffset: '15px'}};

    return (
      <div className="center" style={{ ...style.body, maxWidth: '450px' }}>
        <div className="sub-panel">
          <h3 className="text-left ml10" style={{ ...style.title, marginTop: '0' }}>
            {t.key('title')}
          </h3>

          {exceededTrialPlan &&
            <Alert unclosed={true} messages={[<ExceededMessage/>]} type="exceeded-trial-plan" />
          }

          {enableLocationDropdown &&
          <div className='select-block'>
            <span className='titles'> Location </span>
            <LocationSelect className="mt10" />
          </div>
          }

          {enableResourceDropdown &&
          <div className='select-block'>
            <span className='titles'> {t.key('resourcePrompt')} </span>
            <ResourceSelect className="mt10" />
          </div>
          }

          {enableVariantDropdown &&
          <div className='select-block'>
            <span className='titles'> {t.key('variants')} </span>
            <VariantSelect priceSymbol={t.key('priceSymbol')} className="mt10" />
          </div>
          }

          {showQuantityChooser &&
          <div className='select-block'>
            <span className='titles'> {t.key('quantity')} </span>
            <QuantityInput min={1} />
          </div>
          }

          <div className="relative text-center">
            <Spinner ref={ref => (this.spinner = ref)} />

            <DatePicker
              fixedWeeks
              styled={{...style.datepicker, ...additionalStyle}}
              region={region}
              innerRef={ref => (this.dayPicker = this.dayPicker || ref)}
              fromMonth={moment(firstDate).toDate()}
              toMonth={moment(lastDate).toDate()}
              month={moment(currentMonth || moment(firstDate)).toDate()}
              onMonthChange={this.onMonthClick}
              onDayClick={this.onDayClick}
              renderDay={this.renderDay}
              modifiers={{ disabled: this.dayDisabled, selected: daySelected }}
            >
              {this.isTimeslotsUnderSelectedDay() && this.renderTimeslots()}
            </DatePicker>

            {daySelected && !this.isTimeslotsUnderSelectedDay() && <div className="DayPicker-ExtensionGroup">
              <div className="DayPicker-Extension">
                {this.renderTimeslots()}
              </div>
            </div>}
            
            <Price widgetType="appt" title="Price"/>

            <TimeZone timeZone={timeZone} description="All times in" className="text-left"/>

            {!canBook && <Submit className="submit" canBook={canBook} />}
          </div>
          <Modal
            fullPage
            title={t.key('modalTitle')}
            closeWord={' '}
            getOpenFn={openFn => {this.openModal = openFn;}}
            getCloseFn={closeFn => {this.closeModal = closeFn;}}
          >
            <div className="p15 pb0" style={{ paddingBottom: '0' }}>
              <p className="mt0 description-title">{t.key('descriptionModal')}</p>
              <div>
                <VariantsBlock
                  productTitle={productTitle}
                  variants={variantsValue}
                  selectedTimeSlot={timeSlotSelected}
                  selectedResource={selectedResource}
                  locale={locale}
                  timeZone={timeZone}
                  timeFormat={setting.time_format}
                  priceSymbol={t.key('priceSymbol')}
                  selectDifferentTime={this.closeModal}
                  selectDifferentTimeWord={t.key('wordCloseModal')}
                />
                {showLocationMap && location && <LocationBlock selectedLocation={location} mapUrl={mapUrl} />}
                <Price widgetType="appt" title="Total"/>
              </div>
            </div>
            <div>
              <Alert ref={ref => (this.alert = ref)} />
              <div className="buttons_line">
                <Button styled={style.secondaryButton} className="back ptb15" onClick={this.closeModal}>
                  Back
                </Button>
                <Submit className="submit" canBook onSubmit={e => this.onSubmit(e)} />
              </div>
            </div>
          </Modal>
        </div>
      </div>
    );
  }
}

AppointmentWidgetPage.propTypes = {
  translation: PropTypes.object,
  defaultTranslation: PropTypes.object,
  exceededTrialPlan: PropTypes.bool,
  frames: PropTypes.array,
  locations: PropTypes.array,
  resources: PropTypes.array,
  toggleDay: PropTypes.bool,
  nextOccurrence: PropTypes.string,
  order: PropTypes.object,
  orderActions: PropTypes.shape({
    setVariantsQuantity: PropTypes.func,
    setOrderDetails: PropTypes.func,
  }),
  cartActions: PropTypes.shape({
    addItems: PropTypes.func,
  }),
  style: PropTypes.object,
  setting: PropTypes.object,
  productTitle: PropTypes.string,
};
